<template>
  <div class="pageMain" :class="globalDataArray.siteInfo.greyOut == 1 ? 'bigEventGray' : ''">
    <!-- 第二板块 -->

    <div class="des_new">
      <div class="w1440">
        <div class="e_container-1" v-if="contentInfo!=''&&contentInfo!=null">
          <div class="cbox-1-0">
            <div class="s_title0">
              <h1 class="e_h1-2 fnt_42">{{ contentInfo.data.title }}</h1>
              <div class="time">
                <img src="@/assets/images/new_time.png" alt="">
                <span class="fnt_18" v-if="contentInfo.data.public_time!=''&&contentInfo.data.public_time!=null">{{ contentInfo.data.public_time }}</span>
                <span class="fnt_18" v-else>{{ contentInfo.data.update_time }}</span>
              </div>
            </div>

            <div class="s_title fnt_16 ck-content markdown-content" v-if="contentInfo.data.content!=''&&contentInfo.data.content!=null" v-html="parsedContent">
            </div>

            <div class="s_title fnt_16 ck-content" style="text-align:center;" v-else>{{ globalDataArray.siteTemplateLanguage.system_data_empty_tips }}</div>

            <div class="s_title1">
              <div class="cat_left">
                <p class="tle_p fnt_18" v-if="contentInfo.data.prev"><span class="cbox-21-0">{{ globalDataArray.siteTemplateLanguage.prev_news }}：</span><span class="cbox-21-1"><router-link :to="'/newsinfo?id='+contentInfo.data.prev.parentId">{{ contentInfo.data.prev.title }}</router-link></span></p>
                <p class="tle_p fnt_18" v-if="contentInfo.data.next"><span class="cbox-21-0">{{ globalDataArray.siteTemplateLanguage.next_news }}：</span><span class="cbox-21-1"><router-link :to="'/newsinfo?id='+contentInfo.data.next.parentId">{{ contentInfo.data.next.title }}</router-link></span></p>
              </div>
              <div class="cat_right">
                <div class="cbox-19-0 p_item">
                  <router-link v-if="fromQuery!=''&&fromQuery!=null" :to="'/news?from='+fromQuery" class="e_button-20 fnt_18">
                    <img src="@/assets/images/fhlb.png" alt="">
                    <span>{{ globalDataArray.siteTemplateLanguage.back_list }}</span>
                  </router-link>
                  <router-link v-else to="/news" class="e_button-20 fnt_18">
                    <img src="@/assets/images/fhlb.png" alt="">
                    <span>{{ globalDataArray.siteTemplateLanguage.back_list }}</span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="cbox-1-1" v-if="contentInfo.data.pageRelatedList.records!=''&&contentInfo.data.pageRelatedList.records!=null">
            <div class="s_subtitle fnt_36">{{ globalDataArray.siteTemplateLanguage.info_list_news }}</div>
            <div class="p_item" v-if="contentInfo.data.pageRelatedList">
              <div class="e_loop-28">
                <div class="p_list" style="flex-direction:column;">
                  <template v-for="(item,index) in contentInfo.data.pageRelatedList.records">
                    <div class="e_image-27" :key="index" v-if="index==0"><router-link :to="'/newsinfo?id='+item.parentId"><img :src="item.image" alt=""></router-link></div>
                    <div class="cbox-28" :key="index">
                      <p class="fnt_18 e_text-30" v-if="item.publicTime!=''&&item.publicTime!=null">{{ item.publicTime }}</p>
                      <p class="fnt_18 e_text-30" v-else>{{ item.updateTime }}</p>
                      <p class="e_text-31 s_title fnt_20">
                        <router-link :to="'/newsinfo?id='+item.parentId">
                          {{ item.title }}
                        </router-link>
                      </p>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { message } from 'ant-design-vue'
import { getNewsDetail } from '@/api/news'
import { marked } from 'marked'

// 配置 marked 解析器 - 允许HTML和样式
marked.setOptions({
  breaks: true,
  gfm: true,
  sanitize: false, // 允许HTML标签
  async: false,
  xhtml: false // 使用HTML5风格
})

export default {
  name: 'Newsinfo',
  asyncData({ store, route }) {
    return store.dispatch('getNewsInfo', { id: route.query.id })
  },
  computed: {
    contentInfo() {
      return this.$store.state.newsInfo
    },
    // 解析后的内容
    parsedContent() {
      if (!this.contentInfo?.data?.content) {
        return ''
      }
      // 额外的XSS安全检查
      const safeContent = this.sanitizeContent(this.contentInfo.data.content)
      return this.parseMarkdown(safeContent)
    }
  },
  data() {
    return {
      newsinfoCont: '',
      fromQuery: ''
    }
  },
  mounted() {
    const that = this

    if (that.$store.state.newsInfo == null || that.$store.state.newsInfo == '') {
      message.error(that.globalDataArray.siteTemplateLanguage.system_data_empty_tips)
      let backPath = '/news'
      if (this.$route.query.from) {
        backPath = '/news?from=' + this.$route.query.from
      }

      this.$router.push({ path: backPath })
      return
    }

    if (typeof document === 'object') {
      document.documentElement.scrollTop = 0
    }

    if (this.$route.query.from) {
      this.fromQuery = this.$route.query.from
    }
  },
  methods: {
    // 额外的XSS内容清理函数
    sanitizeContent(content) {
      if (!content || typeof content !== 'string') {
        return content
      }

      let sanitized = content

      // 移除危险的JavaScript协议
      sanitized = sanitized.replace(/javascript:/gi, '')
      sanitized = sanitized.replace(/vbscript:/gi, '')
      sanitized = sanitized.replace(/data:/gi, '')

      // 移除危险的事件处理器
      sanitized = sanitized.replace(/\s+on\w+\s*=\s*["'][^"']*["']/gi, '')
      sanitized = sanitized.replace(/\s+on\w+\s*=\s*[^\s>]+/gi, '')

      // 移除危险的HTML标签
      sanitized = sanitized.replace(/<script[^>]*>.*?<\/script>/gi, '')
      sanitized = sanitized.replace(/<iframe[^>]*>.*?<\/iframe>/gi, '')
      sanitized = sanitized.replace(/<object[^>]*>.*?<\/object>/gi, '')
      sanitized = sanitized.replace(/<embed[^>]*>.*?<\/embed>/gi, '')
      sanitized = sanitized.replace(/<form[^>]*>.*?<\/form>/gi, '')

      // 移除危险的属性
      sanitized = sanitized.replace(/\s+on\w+\s*=\s*["'][^"']*["']/gi, '')
      sanitized = sanitized.replace(/\s+on\w+\s*=\s*[^\s>]+/gi, '')

      return sanitized
    },

    // 强化的HTML实体和转义序列解码函数
    decodeHtmlEntities(content) {
      if (!content || typeof content !== 'string') {
        return content
      }

      let decoded = content

      try {
        // 直接解码常见的JSON转义序列，包括空白字符
        if (decoded.includes('\\u003C') || decoded.includes('\\u002F') || decoded.includes('\\"') || decoded.includes('\\u0020') || decoded.includes('\\u0009')) {
          // 直接替换常见的JSON编码字符，包括各种空白字符
          const jsonReplacements = {
            '\\u003C': '<',
            '\\u003E': '>',
            '\\u002F': '/',
            '\\u0026': '&',
            '\\u0022': '"',
            '\\u0027': "'",
            '\\u003D': '=',
            '\\u0020': ' ', // 普通空格
            '\\u00A0': '\u00A0', // 不换行空格 (NBSP)
            '\\u000A': '\n', // 换行
            '\\u000D': '\r', // 回车
            '\\u0009': '\t', // 制表符
            '\\u000B': '\v', // 垂直制表符
            '\\u000C': '\f' // 换页符
          }
          Object.keys(jsonReplacements).forEach(encoded => {
            if (decoded.includes(encoded)) {
              decoded = decoded.replace(new RegExp(encoded, 'g'), jsonReplacements[encoded])
            }
          })
        }

        // 安全地解码Unicode转义序列（\uXXXX格式），保留空白字符
        decoded = decoded.replace(/\\u([0-9a-fA-F]{4})/g, (match, code) => {
          const charCode = parseInt(code, 16)
          // 保留有用的空白字符，跳过危险的控制字符
          if (charCode >= 0x0000 && charCode <= 0x001F &&
              charCode !== 0x0009 && // tab
              charCode !== 0x000A && // 换行
              charCode !== 0x000D && // 回车
              charCode !== 0x000B && // 垂直制表符
              charCode !== 0x000C) { // 换页符
            return '' // 跳过其他危险的控制字符
          }
          if (charCode >= 0x200B && charCode <= 0x200D) {
            return '' // 跳过零宽字符
          }
          return String.fromCharCode(charCode)
        })

        // 解码各种类型的转义序列，包括空白字符的不同表示形式
        decoded = decoded.replace(/\\n/g, '\n') // 换行
        decoded = decoded.replace(/\\t/g, '\t') // 制表符
        decoded = decoded.replace(/\\r/g, '\r') // 回车
        decoded = decoded.replace(/\\v/g, '\v') // 垂直制表符
        decoded = decoded.replace(/\\f/g, '\f') // 换页符
        decoded = decoded.replace(/\\ /g, ' ') // 转义的空格
        decoded = decoded.replace(/\\"/g, '"') // 双引号
        decoded = decoded.replace(/\\'/g, "'") // 单引号
        decoded = decoded.replace(/\\\\/g, '\\') // 反斜杠（放在最后处理）

        // 手动解码常见的HTML实体，包括各种空白字符
        const htmlEntities = {
          '&amp;': '&',
          '&lt;': '<',
          '&gt;': '>',
          '&quot;': '"',
          '&#39;': "'",
          '&#x27;': "'",
          '&#x2F;': '/',
          '&#x60;': '`',
          '&#x3D;': '=',
          // 空白字符的HTML实体
          '&nbsp;': '\u00A0', // 不换行空格
          '&ensp;': '\u2002', // En空格 (en space)
          '&emsp;': '\u2003', // Em空格 (em space)
          '&thinsp;': '\u2009', // 细空格 (thin space)
          '&#32;': ' ', // 普通空格
          '&#160;': '\u00A0', // 不换行空格 (NBSP)
          '&#9;': '\t', // 制表符
          '&#09;': '\t', // 制表符（前导零）
          '&#x09;': '\t', // 制表符（十六进制）
          '&#x0009;': '\t', // 制表符（十六进制完整）
          '&#13;': '\r', // 回车
          '&#10;': '\n', // 换行
          '&#x0A;': '\n', // 换行（十六进制）
          '&#x0D;': '\r' // 回车（十六进制）
        }

        Object.keys(htmlEntities).forEach(entity => {
          if (decoded.includes(entity)) {
            decoded = decoded.replace(new RegExp(entity, 'g'), htmlEntities[entity])
          }
        })
      } catch (error) {
        // 如果解码失败，至少尝试基本的安全Unicode解码，保留空白字符
        decoded = content.replace(/\\u([0-9a-fA-F]{4})/g, (match, code) => {
          const charCode = parseInt(code, 16)
          // 解码安全字符，包括重要的空白字符
          if ((charCode >= 0x0020 && charCode < 0x200B) || // 基本安全字符范围
              charCode === 0x0009 || // tab
              charCode === 0x000A || // 换行
              charCode === 0x000D || // 回车
              charCode === 0x00A0) { // 不换行空格
            return String.fromCharCode(charCode)
          }
          return ''
        })
      }

      return decoded
    },

    // 清理可能导致DOM错误的字符但保留HTML结构
    cleanDOMBreakingContent(content) {
      if (!content || typeof content !== 'string') {
        return '<p>内容为空</p>'
      }

      try {
        let cleaned = content

        // 1. 移除可能导致appendChild错误的零宽字符和控制字符，但保留有效的空白字符
        cleaned = cleaned.replace(/[\u200B-\u200D\uFEFF]/g, '') // 零宽字符
        // 危险的控制字符，但保留tab(\u0009)、换行(\u000A)、回车(\u000D)
        cleaned = cleaned.replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, '') // 危险的控制字符

        // 2. 清理BOM和替换字符
        cleaned = cleaned.replace(/^\uFEFF/, '') // 移除BOM
        cleaned = cleaned.replace(/\uFFFD/g, '') // 移除替换字符

        // 3. 移除可能导致DOM解析问题的注释节点
        cleaned = cleaned.replace(/<!--[\s\S]*?-->/g, '')

        // 4. 修复嵌套不当的标签
        cleaned = this.fixNestedTags(cleaned)

        // 5. 修复可能的孤立尖括号
        cleaned = this.fixBrokenAngularBrackets(cleaned)

        // 6. 清理可能导致DOM问题的空属性和畸形属性
        cleaned = cleaned.replace(/\s+(\w+)=""\s*/g, ' ') // 移除空属性
        cleaned = cleaned.replace(/\s+(\w+)="\s*"\s*/g, ' ') // 移除只有空白的属性
        cleaned = this.fixMalformedAttributes(cleaned)

        // 7. 最终安全检查
        if (!cleaned.trim()) {
          return '<p>内容为空</p>'
        }

        return cleaned
      } catch (error) {
        console.error('cleanDOMBreakingContent error:', error)
        return `<p style="color: #999;">内容处理出错: ${this.escapeHtml(error.message)}</p>`
      }
    },

    // 修复嵌套不当的HTML标签
    fixNestedTags(content) {
      try {
        let fixed = content

        // 移除p标签内的块级元素嵌套
        fixed = fixed.replace(/<p([^>]*)>([\s\S]*?)<div([^>]*)>([\s\S]*?)<\/div>([\s\S]*?)<\/p>/gi,
          '<p$1>$2</p><div$3>$4</div><p>$5</p>')

        // 修复self-closing标签的问题
        fixed = fixed.replace(/<(br|hr|img|input|meta|link)\s+([^>]*?)\s*>/gi, '<$1 $2 />')

        // 修复未闭合的标签（基础修复）
        const voidElements = ['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'source', 'track', 'wbr']
        voidElements.forEach(tag => {
          const regex = new RegExp(`<${tag}([^>]*?)(?<!/)>`, 'gi')
          fixed = fixed.replace(regex, `<${tag}$1 />`)
        })

        return fixed
      } catch (error) {
        console.warn('修复嵌套标签失败:', error)
        return content
      }
    },

    // 修复破损的尖括号
    fixBrokenAngularBrackets(content) {
      try {
        let fixed = content

        // 更安全的方式处理孤立的尖括号，避免破坏正确的HTML标签
        fixed = fixed.replace(/(?<!<[^>]*)<(?![a-zA-Z\/!?\s])/g, '&lt;')
        fixed = fixed.replace(/(?<![a-zA-Z0-9\s"'=\/])>(?!\s*[<\w])/g, '&gt;')

        // 修复属性中的问题尖括号
        fixed = fixed.replace(/(\w+="[^"]*)<([^">]*")/g, '$1&lt;$2')
        fixed = fixed.replace(/(\w+="[^"]*)>([^">]*")/g, '$1&gt;$2')

        return fixed
      } catch (error) {
        console.warn('修复尖括号失败:', error)
        return content
      }
    },

    // 修复畸形的HTML属性
    fixMalformedAttributes(content) {
      try {
        let fixed = content

        // 修复没有引号的属性值（但只处理安全的情况）
        fixed = fixed.replace(/(\w+)=([a-zA-Z0-9\-_]+)(?=\s|>)/g, '$1="$2"')

        // 修复单引号属性
        fixed = fixed.replace(/(\w+)='([^']*)'/g, '$1="$2"')

        // 移除无效的属性（如属性名包含特殊字符）
        fixed = fixed.replace(/[^\w\-]+="[^"]*"/g, '')

        return fixed
      } catch (error) {
        console.warn('修复属性失败:', error)
        return content
      }
    },

    // HTML转义函数
    escapeHtml(text) {
      if (!text || typeof text !== 'string') return ''

      try {
        if (this.$isServer) {
          // 服务端环境使用简单替换
          return text
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')
        } else {
          // 客户端环境使用DOM方法
          const div = document.createElement('div')
          div.textContent = text
          return div.innerHTML
        }
      } catch (error) {
        // 降级到简单替换
        return text
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;')
      }
    },

    // 检测内容类型是否为Markdown
    detectContentType(content) {
      if (!content || typeof content !== 'string') {
        return false
      }

      // 增强的markdown检测模式
      const markdownPatterns = [
        /^#+ /m, // 标题 (多行模式)
        /^#{1,6}\s+/m, // 标题的另一种写法
        /\[.*?\]\(.*?\)/, // 链接
        /\*\*.*?\*\*/, // 粗体
        /\*.*?\*/, // 斜体
        /`.*?`/, // 行内代码
        /```[\s\S]*?```/, // 代码块
        /^\s*\-\s+/m, // 无序列表
        /^\s*\*\s+/m, // 无序列表
        /^\s*\+\s+/m, // 无序列表
        /^\s*\d+\.\s+/m, // 有序列表
        /^\s*>\s+/m, // 引用
        /^\s*\|\s*.*?\s*\|/m, // 表格
        /^---+$/m, // 分隔线
        /^\s*\n```/m, // 代码块开始
        /~~.*?~~/, // 删除线
        /==.*?==/, // 高亮
        /^\s{4,}/m, // 代码缩进
        /\n\s*\n/, // 多个空行
        /\*\*\*.*/m // 分隔线（三个星号）
      ]

      // 检查是否包含markdown特征
      const hasMarkdownFeatures = markdownPatterns.some(pattern => pattern.test(content))

      // 如果包含HTML标签且没有明显markdown特征，优先判断为HTML
      if (/<[^>]*>/g.test(content) && !hasMarkdownFeatures) {
        return false // 返回false表示不是markdown，应该按HTML处理
      }

      // 如果没有检测到markdown特征，但内容包含换行符且不是HTML，也可能是markdown纯文本
      if (!hasMarkdownFeatures && content.includes('\n') && !/<[^>]*>/g.test(content)) {
        // 检查是否是纯文本格式的markdown（简单的换行格式）
        const lines = content.split('\n')
        const hasStructure = lines.some(line => {
          const trimmed = line.trim()
          return trimmed.startsWith('#') ||
              trimmed.startsWith('-') ||
              trimmed.startsWith('*') ||
              trimmed.startsWith('+') ||
              /^\d+\./.test(trimmed)
        })
        return hasStructure
      }

      return hasMarkdownFeatures
    },

    // Markdown解析函数
    parseMarkdown(content) {
      try {
        if (!content || typeof content !== 'string') {
          return '<p>内容为空</p>'
        }

        // 先解码HTML实体和Unicode转义序列
        const decodedContent = this.decodeHtmlEntities(content)

        // 检测内容类型
        const isMarkdown = this.detectContentType(decodedContent)

        if (isMarkdown) {
          const parsed = marked.parse(decodedContent)
          if (!parsed || parsed.trim() === '') {
            return `<div class="markdown-fallback"><pre>${this.cleanDOMBreakingContent(decodedContent)}</pre></div>`
          }

          // 对解析后的内容进行安全清理，但保留HTML结构
          const cleanedParsed = this.cleanDOMBreakingContent(parsed)
          return cleanedParsed
        } else {
          // 如果不是markdown，按HTML处理
          if (decodedContent.includes('<') && decodedContent.includes('>')) {
            return this.cleanDOMBreakingContent(decodedContent)
          } else {
            // 对于纯文本，至少保留换行符
            const textWithBreaks = decodedContent.replace(/\n/g, '<br>')
            return this.cleanDOMBreakingContent(textWithBreaks)
          }
        }
      } catch (e) {
        console.error('parseMarkdown: 解析失败:', e)
        return `<div class="markdown-error">
          <p class="error">Markdown解析异常</p>
          <details>
            <summary>查看原始内容</summary>
            <pre>${content}</pre>
          </details>
        </div>`
      }
    }
  },
  metaInfo() {
    let title = this.globalDataArray.siteInfo.title
    let description = this.globalDataArray.siteInfo.description
    let keywords = this.globalDataArray.siteInfo.keywords
    if (this.$store.state.newsInfo != '' && this.$store.state.newsInfo != null) {
      if (this.$store.state.newsInfo.data.title != '' && this.$store.state.newsInfo.data.title != null) {
        title = this.$store.state.newsInfo.data.title + '-' + this.globalDataArray.siteInfo.title
      }
      if (this.$store.state.newsInfo.data.description != '' && this.$store.state.newsInfo.data.description != null) {
        description = this.$store.state.newsInfo.data.description
      }
      if (this.$store.state.newsInfo.data.keywords != '' && this.$store.state.newsInfo.data.keywords != null) {
        keywords = this.$store.state.newsInfo.data.keywords
      }
    }
    return {
      title: title,
      meta: [
        { vmid: 'description', name: 'description', content: description },
        { vmid: 'keywords', name: 'keywords', content: keywords }
      ]
    }
  }
}
</script>
<style>
@import '@/assets/css/news_des.css';

/* Markdown内容表格样式 - GitHub风格 */
/* 非scoped样式，确保能够作用到v-html渲染的表格内容 */
.markdown-content table {
  border-collapse: collapse !important;
  border-spacing: 0 !important;
  width: 100% !important;
  margin: 16px 0 !important;
  background-color: #fff !important;
  border: 1px solid #d0d7de !important;
  border-radius: 6px !important;
  overflow: hidden !important;
  font-size: 14px !important;
  line-height: 1.45 !important;
  color: #24292f !important;

  /* 确保在SSR环境下正确渲染 */
  box-sizing: border-box !important;
  display: table !important;
}

/* 表格头部样式 - GitHub设计 */
.markdown-content table thead,
.markdown-content table thead tr {
  background-color: #f6f8fa !important;
  border-bottom: 2px solid #d0d7de !important;
}

/* 表头单元格样式 */
.markdown-content table th {
  padding: 12px 16px !important;
  text-align: left !important;
  font-weight: 600 !important;
  color: #24292f !important;
  background-color: #f6f8fa !important;
  border: 1px solid #d0d7de !important;
  border-bottom: 2px solid #d0d7de !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: 200px !important;
}

/* 表格主体样式 */
.markdown-content table tbody {
  background-color: #fff !important;
}

/* 表格行样式 - 斑马纹效果 */
.markdown-content table tbody tr {
  border-bottom: 1px solid #d0d7de !important;
  transition: background-color 0.2s ease !important;
}

/* 偶数行背景色 - 斑马纹 */
.markdown-content table tbody tr:nth-child(even) {
  background-color: #f6f8fa !important;
}

/* 悬停效果 */
.markdown-content table tbody tr:hover {
  background-color: #eef4fd !important;
}

/* 表格数据单元格样式 */
.markdown-content table td {
  padding: 8px 16px !important;
  border: 1px solid #d0d7de !important;
  color: #24292f !important;
  background-color: inherit !important;
  vertical-align: top !important;
  word-wrap: break-word !important;
  max-width: 300px !important;
  overflow-wrap: break-word !important;
}

/* 通用链接样式 - 默认使用蓝色 */
.markdown-content a {
  color: #0969da; /* 默认蓝色 */
  text-decoration: none !important;
  border-bottom: 1px solid transparent !important;
  transition: all 0.2s ease !important;
}

/* 有颜色父级容器时，链接继承颜色 */
.markdown-content [style*="color"] a {
  color: inherit !important; /* 继承父元素的颜色 */
}

.markdown-content a:hover {
  text-decoration: none !important;
  border-bottom: 1px solid currentColor !important;
}

/* 表格内链接样式 - 继承通用样式 */
.markdown-content table a {
  color: #0969da; /* 默认蓝色 */
  text-decoration: none !important;
  border-bottom: 1px solid transparent !important;
  transition: all 0.2s ease !important;
}

/* 表格内有颜色父级容器时，链接继承颜色 */
.markdown-content table [style*="color"] a {
  color: inherit !important; /* 继承父元素的颜色 */
}

.markdown-content table a:hover {
  border-bottom: 1px solid currentColor !important;
  text-decoration: none !important;
}

/* 表格内代码样式 */
.markdown-content table code {
  background-color: #f3f4f6 !important;
  color: #24292f !important;
  padding: 2px 6px !important;
  border-radius: 3px !important;
  font-size: 13px !important;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;
  border: none !important;
}

/* 表格内强调文本样式 */
.markdown-content table strong,
.markdown-content table b {
  font-weight: 600 !important;
  color: #24292f !important;
}

/* 表格内斜体样式 */
.markdown-content table em,
.markdown-content table i {
  font-style: italic !important;
  color: #656d76 !important;
}

/* ==================== 响应式适配 ==================== */

/* 大屏幕优化 (1200px+) */
@media screen and (min-width: 1200px) {
  .markdown-content table {
    font-size: 15px !important;
  }

  .markdown-content table th,
  .markdown-content table td {
    padding: 12px 20px !important;
  }
}

/* 中等屏幕 (768px - 1199px) */
@media screen and (min-width: 768px) and (max-width: 1199px) {
  .markdown-content table {
    font-size: 14px !important;
  }

  .markdown-content table th,
  .markdown-content table td {
    padding: 10px 14px !important;
    max-width: 250px !important;
  }
}

/* 移动端适配 (768px以下) */
@media screen and (max-width: 768px) {
  /* 覆盖news_des.css中的强制字体样式 */
  .markdown-content table,
  .markdown-content table * {
    font-size: 12px !important;
    line-height: 1.4 !important;
  }

  /* 移动端表格容器 - 横向滚动 */
  .markdown-content {
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch !important;
  }

  /* 移动端表格样式调整 */
  .markdown-content table {
    min-width: 500px !important; /* 确保表格有最小宽度 */
    margin: 12px 0 !important;
    border-radius: 4px !important;
  }

  .markdown-content table th,
  .markdown-content table td {
    padding: 6px 10px !important;
    max-width: 150px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  /* 移动端表头样式 */
  .markdown-content table th {
    font-size: 11px !important;
    font-weight: 600 !important;
    padding: 8px 10px !important;
  }
}

/* 超小屏幕 (480px以下) */
@media screen and (max-width: 480px) {
  .markdown-content table {
    font-size: 11px !important;
    min-width: auto !important;
  }

  .markdown-content table th,
  .markdown-content table td {
    padding: 4px 8px !important;
    max-width: 120px !important;
    font-size: 10px !important;
  }
}

/* ==================== 特殊情况处理 ==================== */

/* 处理可能的表格嵌套情况 */
.markdown-content table table {
  margin: 0 !important;
  border: none !important;
  border-radius: 0 !important;
}

/* 处理空表格的情况 */
.markdown-content table:empty {
  display: none !important;
}

/* Marked v15.0.7 特殊HTML结构兼容 */
.markdown-content table > thead > tr > th,
.markdown-content table > tbody > tr > td,
.markdown-content table > tr > th,
.markdown-content table > tr > td {
  /* 确保兼容Marked可能输出的各种表格结构 */
  border: 1px solid #d0d7de !important;
  padding: 8px 16px !important;
}

/* ==================== Toast UI Editor 一致性表格样式 ==================== */
/* 简洁的Markdown内容表格样式 - 与Toast UI Editor预览保持一致 */
.markdown-content table {
  /* 基础表格样式 - 与Toast UI Editor预览保持一致 */
  border-collapse: collapse !important;
  border-spacing: 0 !important;
  width: 100% !important;
  margin: 16px 0 !important;
  background-color: #fff !important;

  /* 添加明显的外部边框 - 确保与编辑器预览一致 */
  border: 2px solid #ddd !important;

  /* 简单样式，不使用圆角等装饰 */
  border-radius: 0 !important;
  font-size: 14px !important;
  line-height: 1.6 !important;
  color: #333 !important;

  /* 确保在SSR环境下正确渲染 */
  box-sizing: border-box !important;
  display: table !important;
}

/* 表格头部样式 - 简单清晰 */
.markdown-content table thead,
.markdown-content table thead tr {
  background-color: #f8f9fa !important;
}

/* 表头单元格样式 - 与Toast UI Editor保持一致 */
.markdown-content table th {
  padding: 10px 12px !important;
  text-align: left !important;
  font-weight: bold !important;
  color: #333 !important;
  background-color: #f8f9fa !important;
  border: 1px solid #ddd !important;
  border-bottom: 2px solid #ddd !important;
  vertical-align: middle !important;
}

/* 表格主体样式 */
.markdown-content table tbody {
  background-color: #fff !important;
}

/* 表格行样式 - 简单边框，不使用斑马纹 */
.markdown-content table tbody tr {
  background-color: #fff !important;
}

/* 表格数据单元格样式 - 与编辑器预览保持一致 */
.markdown-content table td {
  padding: 10px 12px !important;
  border: 1px solid #ddd !important;
  color: #333 !important;
  background-color: #fff !important;
  vertical-align: top !important;
  word-wrap: break-word !important;
}

/* 表格内链接样式 - 简单蓝色链接 */
.markdown-content table a {
  color: #007bff !important;
  text-decoration: underline !important;
}

.markdown-content table a:hover {
  color: #0056b3 !important;
  text-decoration: underline !important;
}

/* 表格内代码样式 */
.markdown-content table code {
  background-color: #f1f3f4 !important;
  color: #333 !important;
  padding: 2px 4px !important;
  border-radius: 3px !important;
  font-size: 85% !important;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;
}

/* 表格内强调文本样式 */
.markdown-content table strong,
.markdown-content table b {
  font-weight: bold !important;
  color: #333 !important;
}

/* 表格内斜体样式 */
.markdown-content table em,
.markdown-content table i {
  font-style: italic !important;
  color: #333 !important;
}

/* ==================== 响应式适配 - 保持一致性 ==================== */

/* 移动端适配 (768px以下) - 覆盖全局CSS但保持编辑器一致性 */
@media screen and (max-width: 768px) {
  /* 覆盖news_des.css中的强制字体样式 */
  .markdown-content table,
  .markdown-content table * {
    font-size: 12px !important;
    line-height: 1.4 !important;
  }

  /* 移动端表格容器 - 横向滚动 */
  .markdown-content {
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch !important;
  }

  /* 移动端表格样式调整 */
  .markdown-content table {
    min-width: 500px !important; /* 确保表格有最小宽度 */
    margin: 12px 0 !important;
    font-size: 12px !important;
  }

  .markdown-content table th,
  .markdown-content table td {
    padding: 8px 10px !important;
    font-size: 12px !important;
  }
}

/* 超小屏幕 (480px以下) */
@media screen and (max-width: 480px) {
  .markdown-content table {
    font-size: 11px !important;
    min-width: auto !important;
  }

  .markdown-content table th,
  .markdown-content table td {
    padding: 6px 8px !important;
    font-size: 11px !important;
  }
}

/* ==================== Toast UI Editor 兼容性处理 ==================== */

/* 确保Toast UI Editor渲染的表格结构正确显示 */
.markdown-content table > thead > tr > th,
.markdown-content table > tbody > tr > td,
.markdown-content table > tr > th,
.markdown-content table > tr > td {
  border: 1px solid #ddd !important;
  padding: 10px 12px !important;
}

/* 处理可能的表格嵌套情况 */
.markdown-content table table {
  margin: 0 !important;
  border: 1px solid #ddd !important;
}

/* 处理空表格的情况 */
.markdown-content table:empty {
  display: none !important;
}

/* ==================== Markdown错误处理和降级样式 ==================== */

/* Markdown相关样式 */
.markdown-fallback {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 16px;
  margin: 16px 0;
}

.markdown-error {
  background: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 6px;
  padding: 16px;
  margin: 16px 0;
}

.markdown-error .error {
  color: #ff4d4f;
  font-weight: 500;
  margin-bottom: 12px;
}

.markdown-error details {
  margin-top: 12px;
}

.markdown-error summary {
  cursor: pointer;
  color: #666;
  font-size: 14px;
  margin-bottom: 8px;
}

.markdown-error pre {
  background: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.5;
  overflow-x: auto;
  max-height: 300px;
  overflow-y: auto;
}

/* 确保内容区域正确显示空白字符 */
.txt.ck-content {
  white-space: pre-wrap; /* 保留空格和换行 */
  tab-size: 4; /* 设置tab显示宽度 */
  -moz-tab-size: 4;
  -o-tab-size: 4;
}

.txt.ck-content pre,
.txt.ck-content code {
  white-space: pre-wrap;
  tab-size: 4;
  -moz-tab-size: 4;
  -o-tab-size: 4;
}

.markdown-fallback pre {
  margin: 0;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 14px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
  tab-size: 4; /* 设置tab显示为4个空格宽度 */
  -moz-tab-size: 4;
  -o-tab-size: 4;
}

/* Markdown内容标题样式 */
.markdown-content h1,
.markdown-content h2,
.markdown-content h3,
.markdown-content h4,
.markdown-content h5,
.markdown-content h6,
.txt.ck-content h1,
.txt.ck-content h2,
.txt.ck-content h3,
.txt.ck-content h4,
.txt.ck-content h5,
.txt.ck-content h6 {
  font-weight: bold !important;
}
</style>
